import component from "./CheckInHome";

export default component;
